import { VueConstructor } from 'vue';
import { DataType } from '@/core/data/DataType';

export class ReportBlockWrapper {
    constructor (
        public component: VueConstructor,
        public name: string,
        public iconHtml: string,
        public requiredTypes: DataType[],
        public canBeDisplayed: () => boolean
    ) { }
}